export class BroadbandStaticData {
    public static readonly BROADBAND_OFFER_NAME: string = 'RO_Broadband_PRC';
    public static readonly BROADBAND_SERVICE_BANDWIDTH_NAME: string = 'SRV_BROADBAND:BANDWIDTH';
    public static readonly BROADBAND_DISCOUNT_WHEN_BUYING_TV_PACKAGE_CHARGE_NAME: string = 'BB_MULTI_PLAY_DISC';
    public static readonly BROADBAND_SETUP_CHARGE_NAME: string = 'SETUP_FEE_BB';
    public static readonly BROADBAND_SETUP_DISCOUNT_CHARGE_NAME: string = 'PRC_BB_SETUP_DISC';
    public static readonly BROADBAND_ACTIVATION_CHARGE_NAME: string = 'INST_ACTIVATION';
    public static readonly BROADBAND_ACTIVATION_DISCOUNT_CHARGE_NAME: string = 'INST_ACTIVATION_DISC';
}
